<template>
    <section v-if="project" :id="project.slug" class="project">
        <div class="project__bg"></div>
        <div class="project__nav">
            <div class="pt-1 pl-1 pl-md-2 d-flex flex-row-reverse justify-content-end d-md-block">
                <div class="main-header__logo">
                    <router-link to="/" class="d-none d-md-inline">rschumachr</router-link>
                    <div class="project__title">{{ project.title }}</div>
                </div>
                <div class="mt-0 mr-1 mt-md-2">
                    <router-link to="/#work">
                        <svg style="width:1.5rem;height:2.5rem;" aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>
                    </router-link>
                </div>
            </div>
        </div>
        <component
            v-for="(block, index) in blocks"
            :key="index"
            :is="block.component"
            :block="block" />
    </section>
</template>

<script>
import Axios from 'axios'

export default {
    data() {
        return {
            project: {},
            slug: this.$route.params.slug
        }
    },

    created() {
        Axios.get(`${this.$VUE_APP_API_URL}/projects?slug=${this.slug}`).then(res =>{
            this.project = res.data[0]
        })
    },

    computed: {
        blocks() {
            if(this.project.content) {
                return this.project.content.map(block => {
                    let name = block.__component.substr(6)
                    delete block.__component
                    block.component = require(`./blocks/${name}.vue`).default
                    return block
                })
            }
            return []
        }
    }
}
</script>